import _styled from "@emotion/styled-base";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx } from '@emotion/core';
import { COLORS } from '../../constants';
import getSvgContent from './svgContent';
import '@trustpilot/icons/lib/styles.css';

var StyledSvg = _styled("svg", {
  target: "etx31ro0",
  label: "StyledSvg"
})(function (props) {
  return {
    fill: props.color
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

export var Icon = function Icon(_a) {
  var content = _a.content,
      _b = _a.color,
      color = _b === void 0 ? COLORS.grays.darkest : _b,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      testId = _a["data-testid"],
      onClick = _a.onClick;

  var _d = getSvgContent(content),
      _e = _d.attributes,
      iconClass = _e["class"],
      width = _e.width,
      height = _e.height,
      attributes = __rest(_e, ["class", "width", "height"]),
      innerHTML = _d.innerHTML;

  return jsx(StyledSvg, __assign({
    width: width,
    height: height,
    viewBox: "0 0 " + width + " " + height,
    color: color,
    className: [iconClass, className].join(' '),
    "data-testid": testId,
    onClick: onClick
  }, attributes, {
    dangerouslySetInnerHTML: {
      __html: innerHTML
    }
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Icon/index.js
// module id = 24
// module chunks = 0